export interface ClampForecastExpectedArrivalCell {
  expected_arrival_date: string | null;
}

export interface ClampForecastExpectedArrivalPoLink {
  /** Same date as Incoming parts “Expected” for this PO line. */
  expected_arrival: string | null;
}

/** YYYY-MM-DD → YYYY-MM-01 for the calendar month of that date. */
export function clampForecastArrivalMonthFromIso(isoDate: string): string | null {
  const trimmed = isoDate.trim();
  const match = /^(\d{4}-\d{2})-\d{2}$/.exec(trimmed);
  if (match == null) return null;
  return `${match[1]}-01`;
}

function firstNonEmptyDate(values: Array<string | null | undefined>): string | null {
  for (const value of values) {
    const trimmed = value?.trim();
    if (trimmed != null && trimmed !== "") return trimmed;
  }
  return null;
}

/** Earliest Incoming-parts expected date across linked PO lines. */
export function resolveClampForecastPoExpectedArrivalDate(
  poLinks: ClampForecastExpectedArrivalPoLink[],
): string | null {
  if (poLinks.length === 0) return null;
  const dates = poLinks
    .map((link) => link.expected_arrival)
    .filter((value): value is string => value?.trim() !== "" && value != null)
    .sort();
  return dates.length > 0 ? dates[0]! : null;
}

/**
 * When forecast quantity feeds derived-demand arrivals, use only explicit dates:
 * the cell's expected_arrival_date, or a linked PO's Incoming-parts expected date.
 */
export function resolveClampForecastExpectedArrivalDate(
  cell: ClampForecastExpectedArrivalCell,
  poLinks: ClampForecastExpectedArrivalPoLink[] = [],
): string | null {
  return firstNonEmptyDate([
    cell.expected_arrival_date,
    resolveClampForecastPoExpectedArrivalDate(poLinks),
  ]);
}
